import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Gauge, ChevronDown, ChevronUp, RefreshCw } from "lucide-react";
import { t, fmtNumber } from "../../i18n";

export function QuotaMonitor() {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState(null);

  const load = () => api.get("/youtube/quota").then(({ data }) => setQ(data)).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  const used = q?.used ?? 0;
  const limit = q?.limit ?? 10000;
  const pct = Math.min(100, Math.round((used / limit) * 100));
  const color = pct >= 90 ? "#ef4444" : pct >= 70 ? "#f59e0b" : "#22c55e";

  return (
    <div className="border-b border-border/60" data-testid="quota-monitor">
      <button
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between px-3 py-2 bg-secondary/40 hover:bg-secondary/70 transition-colors"
        data-testid="quota-toggle"
      >
        <span className="text-[10px] font-mono tracking-[0.2em] text-foreground/80 flex items-center gap-1.5">
          <Gauge className="h-3.5 w-3.5 text-primary" /> {t("COTA YOUTUBE")}
        </span>
        <span className="flex items-center gap-2">
          <span className="text-[11px] font-mono font-bold" style={{ color }} data-testid="quota-pct">{pct}%</span>
          {open ? <ChevronUp className="h-3.5 w-3.5" /> : <ChevronDown className="h-3.5 w-3.5" />}
        </span>
      </button>

      {open && (
        <div className="p-3 space-y-2" data-testid="quota-body">
          <div className="h-2 w-full rounded-full bg-input overflow-hidden">
            <div style={{ width: `${pct}%`, background: color }} className="h-full rounded-full transition-all duration-500" data-testid="quota-bar" />
          </div>
          <div className="flex justify-between items-center text-[11px] text-muted-foreground">
            <span data-testid="quota-usage">{fmtNumber(used)} / {fmtNumber(limit)} {t("un.")}</span>
            <button onClick={load} className="flex items-center gap-1 hover:text-foreground" data-testid="quota-refresh">
              <RefreshCw className="h-3 w-3" /> {t("atualizar")}
            </button>
          </div>
          {q?.calls && (
            <div className="text-[10px] text-muted-foreground grid grid-cols-3 gap-1">
              <span>{t("vídeos")}: {q.calls.videos || 0}</span>
              <span>{t("canais")}: {q.calls.channels || 0}</span>
              <span>chat: {q.calls.chat || 0}</span>
            </div>
          )}
          <p className="text-[10px] text-muted-foreground">{t("Reinicia diariamente (limite padrão 10.000 un./dia).")}</p>
        </div>
      )}
    </div>
  );
}
